export default "__VITE_ASSET__Br$MVSM4__"